import { Body, Container, Thumb } from './styles';

export type ToggleSwitchProps = {
	checked: boolean;
	children?: React.ReactNode;
	width?: number;
	height?: number;
	thumbSize?: number;
	color?: string;
	activeColor?: string;
};

export const ToggleSwitch = ({
	checked,
	children,
	width = 70,
	height = 32,
	thumbSize = height - 8,
	color,
	activeColor,
}: ToggleSwitchProps) => {
	return (
		<Container width={width} height={height}>
			<Body
				color={checked ? activeColor : color}
				offset={Math.max(0, (thumbSize - height) / 2)}
				height={height}
			/>
			<Thumb
				offset={Math.max(0, (height - thumbSize) / 2)}
				size={thumbSize}
				checked={checked}
			>
				{children}
			</Thumb>
		</Container>
	);
};
